"use strict";
/**
 * @fileoverview gRPC-Web generated client stub for loopup.ctgateway.v2
 * @enhanceable
 * @public
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoginAPIClient = void 0;
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck
var grpcWeb = require("grpc-web");
var v2_login_api_pb = require("../v2/login_api_pb");
var LoginAPIClient = /** @class */ (function () {
    function LoginAPIClient(hostname, credentials, options) {
        this.methodInfoCreateLogin = new grpcWeb.MethodDescriptor('/loopup.ctgateway.v2.LoginAPI/CreateLogin', grpcWeb.MethodType.UNARY, v2_login_api_pb.CreateLoginRequest, v2_login_api_pb.CreateLoginResponse, function (request) {
            return request.serializeBinary();
        }, v2_login_api_pb.CreateLoginResponse.deserializeBinary);
        this.methodInfoSendInvite = new grpcWeb.MethodDescriptor('/loopup.ctgateway.v2.LoginAPI/SendInvite', grpcWeb.MethodType.UNARY, v2_login_api_pb.SendInviteRequest, v2_login_api_pb.SendInviteResponse, function (request) {
            return request.serializeBinary();
        }, v2_login_api_pb.SendInviteResponse.deserializeBinary);
        this.methodInfoBatchSendInvite = new grpcWeb.MethodDescriptor('/loopup.ctgateway.v2.LoginAPI/BatchSendInvite', grpcWeb.MethodType.SERVER_STREAMING, v2_login_api_pb.BatchSendInviteRequest, v2_login_api_pb.BatchSendInviteResponse, function (request) {
            return request.serializeBinary();
        }, v2_login_api_pb.BatchSendInviteResponse.deserializeBinary);
        this.methodInfoUnassignLoginAuthenticationMethod = new grpcWeb.MethodDescriptor('/loopup.ctgateway.v2.LoginAPI/UnassignLoginAuthenticationMethod', grpcWeb.MethodType.UNARY, v2_login_api_pb.UnassignLoginAuthenticationMethodRequest, v2_login_api_pb.UnassignLoginAuthenticationMethodResponse, function (request) {
            return request.serializeBinary();
        }, v2_login_api_pb.UnassignLoginAuthenticationMethodResponse.deserializeBinary);
        this.methodInfoUpdateLogin = new grpcWeb.MethodDescriptor('/loopup.ctgateway.v2.LoginAPI/UpdateLogin', grpcWeb.MethodType.UNARY, v2_login_api_pb.UpdateLoginRequest, v2_login_api_pb.UpdateLoginResponse, function (request) {
            return request.serializeBinary();
        }, v2_login_api_pb.UpdateLoginResponse.deserializeBinary);
        this.methodInfoGetLogin = new grpcWeb.MethodDescriptor('/loopup.ctgateway.v2.LoginAPI/GetLogin', grpcWeb.MethodType.UNARY, v2_login_api_pb.GetLoginRequest, v2_login_api_pb.GetLoginResponse, function (request) {
            return request.serializeBinary();
        }, v2_login_api_pb.GetLoginResponse.deserializeBinary);
        this.methodInfoSetAuthenticationMethods = new grpcWeb.MethodDescriptor('/loopup.ctgateway.v2.LoginAPI/SetAuthenticationMethods', grpcWeb.MethodType.UNARY, v2_login_api_pb.SetAuthenticationMethodsRequest, v2_login_api_pb.SetAuthenticationMethodsResponse, function (request) {
            return request.serializeBinary();
        }, v2_login_api_pb.SetAuthenticationMethodsResponse.deserializeBinary);
        this.methodInfoSetRoles = new grpcWeb.MethodDescriptor('/loopup.ctgateway.v2.LoginAPI/SetRoles', grpcWeb.MethodType.UNARY, v2_login_api_pb.SetRolesRequest, v2_login_api_pb.SetRolesResponse, function (request) {
            return request.serializeBinary();
        }, v2_login_api_pb.SetRolesResponse.deserializeBinary);
        this.methodInfoSetSystemRoles = new grpcWeb.MethodDescriptor('/loopup.ctgateway.v2.LoginAPI/SetSystemRoles', grpcWeb.MethodType.UNARY, v2_login_api_pb.SetSystemRolesRequest, v2_login_api_pb.SetSystemRolesResponse, function (request) {
            return request.serializeBinary();
        }, v2_login_api_pb.SetSystemRolesResponse.deserializeBinary);
        if (!options)
            options = {};
        if (!credentials)
            credentials = {};
        options['format'] = 'text';
        this.client_ = new grpcWeb.GrpcWebClientBase(options);
        this.hostname_ = hostname;
        this.credentials_ = credentials;
        this.options_ = options;
    }
    LoginAPIClient.prototype.createLogin = function (request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/loopup.ctgateway.v2.LoginAPI/CreateLogin', request, metadata || {}, this.methodInfoCreateLogin, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/loopup.ctgateway.v2.LoginAPI/CreateLogin', request, metadata || {}, this.methodInfoCreateLogin);
    };
    LoginAPIClient.prototype.sendInvite = function (request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/loopup.ctgateway.v2.LoginAPI/SendInvite', request, metadata || {}, this.methodInfoSendInvite, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/loopup.ctgateway.v2.LoginAPI/SendInvite', request, metadata || {}, this.methodInfoSendInvite);
    };
    LoginAPIClient.prototype.batchSendInvite = function (request, metadata) {
        return this.client_.serverStreaming(this.hostname_ +
            '/loopup.ctgateway.v2.LoginAPI/BatchSendInvite', request, metadata || {}, this.methodInfoBatchSendInvite);
    };
    LoginAPIClient.prototype.unassignLoginAuthenticationMethod = function (request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/loopup.ctgateway.v2.LoginAPI/UnassignLoginAuthenticationMethod', request, metadata || {}, this.methodInfoUnassignLoginAuthenticationMethod, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/loopup.ctgateway.v2.LoginAPI/UnassignLoginAuthenticationMethod', request, metadata || {}, this.methodInfoUnassignLoginAuthenticationMethod);
    };
    LoginAPIClient.prototype.updateLogin = function (request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/loopup.ctgateway.v2.LoginAPI/UpdateLogin', request, metadata || {}, this.methodInfoUpdateLogin, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/loopup.ctgateway.v2.LoginAPI/UpdateLogin', request, metadata || {}, this.methodInfoUpdateLogin);
    };
    LoginAPIClient.prototype.getLogin = function (request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/loopup.ctgateway.v2.LoginAPI/GetLogin', request, metadata || {}, this.methodInfoGetLogin, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/loopup.ctgateway.v2.LoginAPI/GetLogin', request, metadata || {}, this.methodInfoGetLogin);
    };
    LoginAPIClient.prototype.setAuthenticationMethods = function (request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/loopup.ctgateway.v2.LoginAPI/SetAuthenticationMethods', request, metadata || {}, this.methodInfoSetAuthenticationMethods, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/loopup.ctgateway.v2.LoginAPI/SetAuthenticationMethods', request, metadata || {}, this.methodInfoSetAuthenticationMethods);
    };
    LoginAPIClient.prototype.setRoles = function (request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/loopup.ctgateway.v2.LoginAPI/SetRoles', request, metadata || {}, this.methodInfoSetRoles, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/loopup.ctgateway.v2.LoginAPI/SetRoles', request, metadata || {}, this.methodInfoSetRoles);
    };
    LoginAPIClient.prototype.setSystemRoles = function (request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/loopup.ctgateway.v2.LoginAPI/SetSystemRoles', request, metadata || {}, this.methodInfoSetSystemRoles, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/loopup.ctgateway.v2.LoginAPI/SetSystemRoles', request, metadata || {}, this.methodInfoSetSystemRoles);
    };
    return LoginAPIClient;
}());
exports.LoginAPIClient = LoginAPIClient;
